import { render, staticRenderFns } from "./TopMatter.vue?vue&type=template&id=693ce3a4&scoped=true"
import script from "./TopMatter.vue?vue&type=script&lang=ts"
export * from "./TopMatter.vue?vue&type=script&lang=ts"
import style0 from "./TopMatter.vue?vue&type=style&index=0&id=693ce3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693ce3a4",
  null
  
)

export default component.exports